import { combineReducers } from "redux";

import checkoutReducer from "./slices/checkout";
import serverContextReducer from "./slices/serverContext";
import plansReducer from "./slices/plans";
import recommendedPlanReducer from "./slices/recommendedPlan";
import surveyAnswersReducer from "./slices/surveyAnswers";
import trialReducer from "./slices/trial";
import surveyNameSpaceReducer from "./slices/surveyNameSpace";
import languageReducer from "./slices/language";
import userDataReducer from "./slices/userData";
import koreanProgramReducer from "./slices/koreanProgram";
import subscriptionReducer from "./slices/subscription";
import paymentEnrollmentFormReducer from "./slices/paymentEnrollmentForm";
import deviceInformationReducer from "./slices/deviceInformation";
import geoLocationReducer from "./slices/geoLocation";
import routeIdReducer from "./slices/routeId";

const combinedSlices = combineReducers({
  serverContext: serverContextReducer,
  checkout: checkoutReducer,
  plans: plansReducer,
  recommendedPlan: recommendedPlanReducer,
  surveyAnswers: surveyAnswersReducer,
  trial: trialReducer,
  userData: userDataReducer,
  surveyNameSpace: surveyNameSpaceReducer,
  language: languageReducer,
  koreanProgram: koreanProgramReducer,
  subscription: subscriptionReducer,
  paymentEnrollmentForm: paymentEnrollmentFormReducer,
  deviceInformation: deviceInformationReducer,
  geoLocation: geoLocationReducer,
  routeId: routeIdReducer,
});

export default combinedSlices;
